import script from "./DictionaryIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DictionaryIndex.vue?vue&type=script&setup=true&lang=js"

import "./DictionaryIndex.vue?vue&type=style&index=0&id=419a33a8&lang=css"
import "./DictionaryIndex.vue?vue&type=style&index=1&id=419a33a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419a33a8"]])

export default __exports__